export default {
  label: 'Agentes',
  placeholder: 'Sin agente',
  indifferent: 'Indiferente',
  other: 'otro',
  others: 'otros',
};
